<template>
  <div
    v-if="textRangeGroupCombosFiltered && textRangeGroupCombosFiltered.length > 0"
    class="variation-listing-filters-container"
  >
    <div
      v-for="group in textRangeGroupCombosFiltered"
      :key="group.variationGroupId"
      class="variation-listing-filters-group" ss-container
    >
      <GroupFilter
        v-if="!isBaseGroup(group)"
        class="variation-listing-filters-group-wrapper"
        :group="group"
        :entries="group.variations.chunks"
        :is-base-group="isBaseGroup(group)"
      >
      </GroupFilter>
    </div>
  </div>
</template>

<script>
import GroupFilter from './GroupFilter'

export default {
  name: 'TextRangeGroupListingFilters',
  components: {
    GroupFilter
  },
  props: {
    textRangeGroupCombos: {
      type: Array
    }
  },
  computed: {
    textRangeGroupCombosFiltered () {
      return this.textRangeGroupCombos.filter(
        (combo) => {
          return (combo.variationDisplayType === 'text-range-per-count' || combo.variationDisplayType === 'text-range-per-value') && this.shouldDisplayCombo(combo)
        }
      )
    }
  },
  methods: {
    isBaseGroup (group) {
      return !(group.variationDisplayType === 'text-range-per-count' || group.variationDisplayType === 'text-range-per-value')
    },
    shouldDisplayCombo (combo) {
      return combo.variationGroupDisplayPosition === 0 || combo.variationGroupDisplayPosition === 2
    }
  }
}
</script>
